
import { Box } from '@mui/material';
import {
    EmailIcon,
    EmailShareButton,
    FacebookIcon,
    FacebookMessengerIcon,
    FacebookMessengerShareButton,
    FacebookShareButton,
    FacebookShareCount,
    GabIcon,
    GabShareButton,
    HatenaIcon,
    HatenaShareButton,
    HatenaShareCount,
    InstapaperIcon,
    InstapaperShareButton,
    LineIcon,
    LineShareButton,
    LinkedinIcon,
    LinkedinShareButton,
    LivejournalIcon,
    LivejournalShareButton,
    MailruIcon,
    MailruShareButton,
    OKIcon,
    OKShareButton,
    OKShareCount,
    PinterestIcon,
    PinterestShareButton,
    PinterestShareCount,
    PocketIcon,
    PocketShareButton,
    RedditIcon,
    RedditShareButton,
    RedditShareCount,
    TelegramIcon,
    TelegramShareButton,
    TumblrIcon,
    TumblrShareButton,
    TumblrShareCount,
    TwitterShareButton,
    ViberIcon,
    ViberShareButton,
    VKIcon,
    VKShareButton,
    VKShareCount,
    WeiboIcon,
    WeiboShareButton,
    WhatsappIcon,
    WhatsappShareButton,
    WorkplaceIcon,
    WorkplaceShareButton,
    XIcon,
} from "react-share";
// const boxCss = { display: 'flex', gap: 1, p: 1, borderRadius: 8, }
const boxCss = { display: 'flex' }
export default function ShareButtons({ size = 24, shareUrl, title, imagePath, showCount = false }) {
    return <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.8, color: "white" }}>
        <Box className="bg-hover" sx={{ ...boxCss }}>
            <FacebookShareButton
                url={shareUrl}
                className="Demo__some-network__share-button"
            >
                <FacebookIcon size={size} round />
            </FacebookShareButton>

            {showCount && <div>

                <FacebookShareCount
                    url={shareUrl}
                    className="Demo__some-network__share-count"
                >
                    {(count) => count}
                </FacebookShareCount>
            </div>}
        </Box>

        <Box className="bg-hover" sx={{ ...boxCss }}>
            <FacebookMessengerShareButton
                url={shareUrl}
                appId="521270401588372"
                className="Demo__some-network__share-button"
            >
                <FacebookMessengerIcon size={size} round />
            </FacebookMessengerShareButton>
        </Box>

        <Box className="bg-hover" sx={{ ...boxCss }}>
            <TwitterShareButton
                url={shareUrl}
                title={title}
                className="Demo__some-network__share-button"
            >
                <XIcon size={size} round />
            </TwitterShareButton>
        </Box>

        <Box className="bg-hover" sx={{ ...boxCss }}>
            <TelegramShareButton
                url={shareUrl}
                title={title}
                className="Demo__some-network__share-button"
            >
                <TelegramIcon size={size} round />
            </TelegramShareButton>
        </Box>

        <Box className="bg-hover" sx={{ ...boxCss }}>
            <WhatsappShareButton
                url={shareUrl}
                title={title}
                separator=":: "
                className="Demo__some-network__share-button"
            >
                <WhatsappIcon size={size} round />
            </WhatsappShareButton>
        </Box>

        <Box className="bg-hover" sx={{ ...boxCss }}>
            <LinkedinShareButton
                url={shareUrl}
                className="Demo__some-network__share-button"
            >
                <LinkedinIcon size={size} round />
            </LinkedinShareButton>
        </Box>




        {/* <Box className="bg-hover" sx={{ ...boxCss }}>
            <PinterestShareButton
                url={String(window.location)}
                media={`${String(window.location)}/${imagePath}`}
                className="Demo__some-network__share-button"
            >
                <PinterestIcon size={size} round />
            </PinterestShareButton>

            {showCount && <div>
                <PinterestShareCount
                    url={shareUrl}
                    className="Demo__some-network__share-count"
                />
            </div>}
        </Box>

        <Box className="bg-hover" sx={{ ...boxCss}}>
            <VKShareButton
                url={shareUrl}
                image={`${String(window.location)}/${imagePath}`}
                className="Demo__some-network__share-button"
            >
                <VKIcon size={size} round />
            </VKShareButton>

            {showCount && <div>
                <VKShareCount
                    url={shareUrl}
                    className="Demo__some-network__share-count"
                />
            </div>}
        </Box>

        <Box className="bg-hover" sx={{ ...boxCss}}>
            <OKShareButton
                url={shareUrl}
                image={`${String(window.location)}/${imagePath}`}
                className="Demo__some-network__share-button"
            >
                <OKIcon size={size} round />
            </OKShareButton>

            {showCount && <div>
                <OKShareCount
                    url={shareUrl}
                    className="Demo__some-network__share-count"
                />
            </div>}
        </Box>

        <Box className="bg-hover" sx={{ ...boxCss}}>
            <RedditShareButton
                url={shareUrl}
                title={title}
                windowWidth={660}
                windowHeight={460}
                className="Demo__some-network__share-button"
            >
                <RedditIcon size={size} round />
            </RedditShareButton>

            {showCount && <div>
                <RedditShareCount
                    url={shareUrl}
                    className="Demo__some-network__share-count"
                />
            </div>}
        </Box>

        <Box className="bg-hover" sx={{ ...boxCss}}>
            <GabShareButton
                url={shareUrl}
                title={title}
                windowWidth={660}
                windowHeight={640}
                className="Demo__some-network__share-button"
            >
                <GabIcon size={size} round />
            </GabShareButton>
        </Box>

        <Box className="bg-hover" sx={{ ...boxCss}}>
            <TumblrShareButton
                url={shareUrl}
                title={title}
                className="Demo__some-network__share-button"
            >
                <TumblrIcon size={size} round />
            </TumblrShareButton>

            {showCount && <div>
                <TumblrShareCount
                    url={shareUrl}
                    className="Demo__some-network__share-count"
                />
            </div>}
        </Box>

        <Box className="bg-hover" sx={{ ...boxCss}}>
            <LivejournalShareButton
                url={shareUrl}
                title={title}
                description={shareUrl}
                className="Demo__some-network__share-button"
            >
                <LivejournalIcon size={size} round />
            </LivejournalShareButton>
        </Box>

        <Box className="bg-hover" sx={{ ...boxCss}}>
            <MailruShareButton
                url={shareUrl}
                title={title}
                className="Demo__some-network__share-button"
            >
                <MailruIcon size={size} round />
            </MailruShareButton>
        </Box>

        <Box className="bg-hover" sx={{ ...boxCss}}>
            <EmailShareButton
                url={shareUrl}
                subject={title}
                body="body"
                className="Demo__some-network__share-button"
            >
                <EmailIcon size={size} round />
            </EmailShareButton>
        </Box>

        <Box className="bg-hover" sx={{ ...boxCss}}>
            <ViberShareButton
                url={shareUrl}
                title={title}
                className="Demo__some-network__share-button"
            >
                <ViberIcon size={size} round />
            </ViberShareButton>
        </Box>

        <Box className="bg-hover" sx={{ ...boxCss,}}>
            <WorkplaceShareButton
                url={shareUrl}
                quote={title}
                className="Demo__some-network__share-button"
            >
                <WorkplaceIcon size={size} round />
            </WorkplaceShareButton>
        </Box>

        <Box className="bg-hover" sx={{ ...boxCss,}}>
            <LineShareButton
                url={shareUrl}
                title={title}
                className="Demo__some-network__share-button"
            >
                <LineIcon size={size} round />
            </LineShareButton>
        </Box>

        <Box className="bg-hover" sx={{ ...boxCss}}>
            <WeiboShareButton
                url={shareUrl}
                title={title}
                image={`${String(window.location)}/${imagePath}`}
                className="Demo__some-network__share-button"
            >
                <WeiboIcon size={size} round />
            </WeiboShareButton>
        </Box>

        <Box className="bg-hover" sx={{ ...boxCss}}>
            <PocketShareButton
                url={shareUrl}
                title={title}
                className="Demo__some-network__share-button"
            >
                <PocketIcon size={size} round />
            </PocketShareButton>
        </Box>

        <Box className="bg-hover" sx={{ ...boxCss}}>
            <InstapaperShareButton
                url={shareUrl}
                title={title}
                className="Demo__some-network__share-button"
            >
                <InstapaperIcon size={size} round />
            </InstapaperShareButton>
        </Box>

        <Box className="bg-hover" sx={{ ...boxCss}}>
            <HatenaShareButton
                url={shareUrl}
                title={title}
                windowWidth={660}
                windowHeight={460}
                className="Demo__some-network__share-button"
            >
                <HatenaIcon size={size} round />
            </HatenaShareButton>

            <div>
                <HatenaShareCount
                    url={shareUrl}
                    className="Demo__some-network__share-count"
                />
            </div>
        </Box> */}
    </Box>
}